import classNames from 'classnames'
import { IconType, IconWithBadge, MAP_NAVIGATION_BREAKPOINT, MenuTip, useMediaQuery } from '@msaf/core-react'

export interface MapMenuButtonProps {
  panelName: string
  buttonIcon: IconType
  activePanel?: string | false
  updatePanelState: Function
  appliedFilterCount?: number
}

export default function MapMenuButton({
  panelName,
  buttonIcon,
  activePanel,
  updatePanelState,
  appliedFilterCount,
}: MapMenuButtonProps) {
  // Only show menu tips (on menu button hover) on portrait tablet up:
  const isDesktop = useMediaQuery(`(min-width: ${MAP_NAVIGATION_BREAKPOINT})`)

  const btnClassNames = classNames('c-toolbar-btn', {
    'c-toolbar-btn--active': panelName === activePanel,
  })

  return (
    <button className={btnClassNames} onClick={() => updatePanelState(false, panelName)}>
      <IconWithBadge icon={buttonIcon} iconAriaLabel={panelName} badgeCount={appliedFilterCount} />

      {/* Show tooltip for menu item on hover (if not currently active) */}
      {isDesktop && panelName !== activePanel && <MenuTip label={panelName} isEnabled={isDesktop} />}
    </button>
  )
}
